module.exports = __webpack_public_path__ + "static/img/06_pro.9d2fc76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/06_pro.jpg
// module id = h5B7
// module chunks = 0